import React from 'react';
import styles from './styles.module.scss';

export interface SidebarInfoCardProps {
  /** Card title */
  title?: string;
  /** Card children content */
  children: React.ReactNode;
  /** Header right action (button, icon, etc.) */
  headerAction?: React.ReactNode;
  /** Additional className for card container */
  className?: string;
  /** Additional className for content wrapper */
  contentClassName?: string;
}

/**
 * Base sidebar info card component.
 * Provides consistent card styling for sidebar info cards.
 * Used as base for TournamentInfoCard, MatchInfoCard, CoefficientsCard.
 */
export const SidebarInfoCard: React.FC<SidebarInfoCardProps> = ({
  title,
  children,
  headerAction,
  className,
  contentClassName,
}) => {
  const hasHeader = title || headerAction;

  return (
    <div className={`${styles.sidebarInfoCard} ${className || ''}`}>
      {hasHeader && (
        <div className={styles.cardHeader}>
          {title && <h3 className={styles.cardTitle}>{title}</h3>}
          {headerAction && <div className={styles.headerAction}>{headerAction}</div>}
        </div>
      )}
      <div className={`${styles.cardContent} ${contentClassName || ''}`}>
        {children}
      </div>
    </div>
  );
};

export default SidebarInfoCard;
